import { CompanyDto } from './companyDto'

export class VehicleLockStatusDto {
  vehicleGuid?: string
  vin?: string
  year?: number
  make?: string
  model?: string
  isAppendixBVehicle?: boolean
  exporterCompany?: CompanyDto
  buyerCompany?: CompanyDto
  vehicleDestinationCompany?: CompanyDto
  inboundTripTransporterCompany?: CompanyDto
  isSpecialBondRequired?: boolean
  specialBondNumber?: string
  hasAmountUSD?: boolean
  amountUSDIsGreaterThanZero?: boolean
  hasExporterMileage?: boolean
  hasExporterMileageUnitOfMeasurement?: boolean
  hasWeightGVWR?: boolean
  hasWeightGAWRFR?: boolean
  hasWeightGAWRRR?: boolean
  hasTitleProcessingState?: boolean
  hasTitleDestinationCompany?: boolean
  hasTitleDestinationCompanyAddress?: boolean
  hasVehicleDestinationCompany?: boolean
  hasVehicleDestinationCompanyAddress?: boolean
  hasConvertCluster?: boolean
  hasManufacturerLabelImageExporter?: boolean
  hasTPMSTelltaleImageExporterFileName?: boolean
  amountUSDIsGreaterThanOrEqualToBondThresholdAndHasSpecialBondNumber?: boolean
  amountUSDIsLessThanBondThresholdAndBondNumberAvailable?: boolean
}
